import { ApiError } from './apiClient';

const VALID_EMAIL_MESSAGE = 'Enter a valid email address.';
const PASSWORD_TOO_SHORT_MESSAGE = 'Password must be at least 8 characters.';
const DUPLICATE_EMAIL_MESSAGE = 'An account with this email already exists.';
const GENERIC_MESSAGE = 'Something went wrong. Please try again.';

const getDetailEntries = (error: unknown): Array<{ loc?: unknown; msg?: unknown }> => {
  if (error instanceof ApiError && error.body && typeof error.body === 'object') {
    const detail = (error.body as any).detail;
    if (Array.isArray(detail)) {
      return detail;
    }
  }

  const maybeDetail = (error as any)?.detail;
  return Array.isArray(maybeDetail) ? maybeDetail : [];
};

const getRawMessage = (error: unknown): string => {
  if (error instanceof ApiError) {
    if (typeof error.body === 'string') {
      return error.body;
    }

    if (error.body && typeof error.body === 'object') {
      const detail = (error.body as any).detail;
      if (typeof detail === 'string') {
        return detail;
      }
      if (typeof (error.body as any).message === 'string') {
        return (error.body as any).message;
      }
    }

    return error.message || '';
  }

  if (error instanceof Error) {
    return error.message || '';
  }

  if (typeof error === 'string') {
    return error;
  }

  return '';
};

export const normalizeUserFacingError = (
  error: unknown,
  fallback = GENERIC_MESSAGE
): string => {
  const rawMessage = getRawMessage(error);
  const normalizedMessage = rawMessage.toLowerCase();
  const detailEntries = getDetailEntries(error);

  const hasEmailValidationError = detailEntries.some((entry) => {
    const loc = Array.isArray(entry.loc) ? entry.loc.map(String) : [];
    const msg = String(entry.msg || '').toLowerCase();
    return loc.includes('email') || msg.includes('email address') || msg.includes('@-sign');
  });

  if (hasEmailValidationError) {
    return VALID_EMAIL_MESSAGE;
  }

  if (
    normalizedMessage.includes('at least 8 characters') ||
    normalizedMessage.includes('password too short')
  ) {
    return PASSWORD_TOO_SHORT_MESSAGE;
  }

  if (
    normalizedMessage.includes('email already') ||
    normalizedMessage.includes('already exists') ||
    normalizedMessage.includes('already registered') ||
    normalizedMessage.includes('duplicate key')
  ) {
    return DUPLICATE_EMAIL_MESSAGE;
  }

  if (
    normalizedMessage.includes('network error') ||
    normalizedMessage.includes('failed to fetch') ||
    normalizedMessage.includes('timeout') ||
    normalizedMessage.includes('internal server error')
  ) {
    return GENERIC_MESSAGE;
  }

  return fallback;
};
